module.exports = __webpack_public_path__ + "assets/webgl/LM_1_3.4b97ea7e.jpg";